import { ArrayDataSource } from './BaseDataSources';
import { IFieldValues } from '../Interfaces';


export class FieldValuesSource extends ArrayDataSource<IFieldValues> {
  public constructor(name: string) {
    super('/datasource/contractvalues', {name});
  }
}